import { Navigate, type RouteObject } from 'react-router';
import { recordTabRoutes } from '../../shared/components/record-tab-routes';
import { OWNER_TABS } from './features/owners/owners.paths';
import { OwnerDetailPage } from './features/owners/pages/OwnerDetailPage';
import { TRAILER_TABS } from './features/trailers/trailers.paths';
import { TrailerDetailPage } from './features/trailers/pages/TrailerDetailPage';
import { TRUCK_TABS } from './features/trucks/trucks.paths';
import { TruckDetailPage } from './features/trucks/pages/TruckDetailPage';
import { FLEET_TABS, fleetTabPath } from './fleet.paths';
import { FleetPage } from './pages/FleetPage';
import { RedirectToFleetRecord } from './pages/RedirectToFleetRecord';

/** Fleet's tabs and the trucks, trailers and owners under them; records live under their tab so the sidebar keeps Fleet highlighted. */
export const FLEET_ROUTES: RouteObject[] = [
  { path: 'fleet', element: <Navigate to={fleetTabPath(FLEET_TABS[0])} replace /> },
  ...FLEET_TABS.map((tab) => ({ path: `fleet/${tab}`, element: <FleetPage tab={tab} /> })),
  ...recordTabRoutes('fleet/trucks/:id', TRUCK_TABS, (tab) => <TruckDetailPage tab={tab} />),
  ...recordTabRoutes('fleet/trailers/:id', TRAILER_TABS, (tab) => <TrailerDetailPage tab={tab} />),
  ...recordTabRoutes('fleet/owners/:id', OWNER_TABS, (tab) => <OwnerDetailPage tab={tab} />),
  // Records' old URLs, kept as redirects.
  { path: 'fleet/:id', element: <RedirectToFleetRecord tab="trucks" /> },
  { path: 'trailers/:id', element: <RedirectToFleetRecord tab="trailers" /> },
  { path: 'owners/:id', element: <RedirectToFleetRecord tab="owners" /> },
];
